import { BackgroundType } from '@/constants/enum';
import { IPreview } from '@/types/components/preview';
import styled from 'styled-components';

interface Props {
  templateCSS: IPreview;
  mobileScreen?: boolean;
  pcScreen?: boolean;
  miniScreen?: boolean;
  fullscreen?: boolean;
}

export const PreviewStyled = styled.div<Props>`
  width: 100%;
  /* height: ${(props) => (props.fullscreen ? '600px' : '100%')}; */
  .preview {
    /* height: ${(props) => (props.miniScreen && props.templateCSS.logo ? '550px' : '100%')}; */
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${(props) => (props.pcScreen || props.miniScreen ? '2rem' : '0px')};
    margin: 0 auto;
    background: ${(props) =>
      props.mobileScreen || props.pcScreen
        ? 'none'
        : props.templateCSS.mainBackgroundType === BackgroundType.BackgroundImage
        ? `url(${props.templateCSS.mainBackground})`
        : props.templateCSS.mainBackgroundType === BackgroundType.BackgroundColor
        ? props.templateCSS.mainBackground || ''
        : 'transparent'};
    background-repeat: no-repeat;
    background-size: cover;

    .preview-container {
      width: ${(props) => (props.mobileScreen || props.miniScreen ? '100%' : '90%')};
      background: ${(props) =>
        props.templateCSS.mainBackgroundType === BackgroundType.BackgroundImage ? '' : props?.templateCSS?.popupBackground || ''};
      border: ${(props) =>
        `${props?.templateCSS?.popupBackgroundBorderWidth}px solid ${props?.templateCSS?.popupBackgroundBorderColor}` || ''};
      border-radius: ${(props) => `${props?.templateCSS?.popupBackgroundBorderRadius}px` || ''};
      color: #fff;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: center;
      margin: ${(props) => (props.fullscreen ? '32px 0' : props.templateCSS ? '16px' : '0')};

      .preview-logo {
        padding: 3rem 0rem 0rem;
        img {
          max-width: 150px;
          max-height: 150px;
        }
      }

      .preview-title {
        padding: 3rem 0.5rem 0.5rem;
        text-align: center;
        word-break: break-word;
        line-height: 2rem;
        font-weight: 700;
      }

      .preview-content {
        padding: 1rem;
        text-align: center;
        word-break: break-word;
        font-size: ${(props) =>
          props.mobileScreen ? +props.templateCSS.subHeadingSize / 1.2 + 'px' : props.templateCSS.subHeadingSize + 'px'};
        color: ${(props) => props?.templateCSS?.subHeadingColor || ''};
        font-weight: 600;
        line-height: 2rem;
      }

      .preview-content,
      .preview-title {
        li span {
          margin-left: 20px;
        }
      }

      .preview-date {
        display: flex;
        justify-content: space-between;
        select {
          border-radius: 4px;
          margin: 0.5rem 0.1rem 0;
          min-height: 25px;
          max-width: 100px;
        }
      }

      .preview-group-btn {
        margin: 0rem 3rem 1rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .submit-button,
        .cancel-button {
          margin: 0.5rem;
          width: 180px;
          height: 40px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          &:hover {
            opacity: 0.8;
            transition: all 0.2s ease;
          }
        }
        .submit-button {
          background-color: ${(props) => props?.templateCSS?.submitButtonBackground || ''};
          border-radius: ${(props) => `${props?.templateCSS?.submitButtonBorderRadius}px` || ''};
          border: ${(props) =>
            `${props?.templateCSS?.submitButtonBorderWidth}px solid ${props?.templateCSS?.submitButtonBorderColor}` || ''};
        }

        .cancel-button {
          background-color: ${(props) => props?.templateCSS?.cancelButtonBackground || ''};
          border-radius: ${(props) => `${props?.templateCSS?.cancelButtonBorderRadius}px` || ''};
          border: ${(props) =>
            `${props?.templateCSS?.cancelButtonBorderWidth}px solid ${props?.templateCSS?.cancelButtonBorderColor}` || ''};
        }

        .submit-button *,
        .cancel-button * {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .watermark-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 2rem;
        img {
          margin: 0 4px;
        }
        .watermark-link {
          color: rgba(0, 91, 211, 1);
          text-decoration: underline;
          cursor: pointer;
        }
      }

      @media screen and (min-width: 709px) and (max-width: 996px) {
        .preview-group-btn {
          button {
            width: 122px;
            height: 35px;
          }
        }
      }
    }
  }
`;
